/* eslint-disable */
import { ofType, ActionsObservable } from "redux-observable";
import { switchMap, catchError, mergeMap, filter } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { ajax } from "rxjs/ajax";
import { AppStats } from "../actions";
import { API_BOS_URL } from "../config/settings";
import { Headers } from "../utilites/Headers";
import { toast } from "react-toastify";
import moment from "moment";

const defaultPayload = { startDate: moment().subtract(7, "days").startOf("day").toISOString(), endDate: moment().endOf("day").toISOString() };

export const getOrderedPoliciesEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "newPolicies" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/orderedPolicies`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "newPolicies" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getAddedPoliciesEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "orderedPolicies" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/addedPolicies`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "orderedPolicies" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getOrderedInstallementsEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "installments" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/orderedInstallments`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "installments" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getPaidFinesEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "fines" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/paidFines`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "fines" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getVignettesEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "vignettes" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/orderedVignettes`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "vignettes" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getParkingEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "parkingZones" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/parking`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "parkingZones" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getClaimsEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "claims" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/claims`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "claims" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getManualExpensesEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "costs" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/manualExpenses`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "costs" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getManualEventsEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "calendar" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/manualEvents`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "calendar" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getGeoWashEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "geoWash" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/geoWash`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );

export const getDashCamEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "dash" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/dashcam`,
        //  url: `${API_BOS_URL}/stats/dashcam`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "dash" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );

export const getDashCamStatsAdminEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "dashCam" || !payload?.tab),
    switchMap(({ onSuccess, payload }) => {
      const period = payload?.tab === "dashCam" ? payload : defaultPayload;
      const startDate = period?.startDate || moment().subtract(7, "days").startOf("day").toISOString();
      const endDate = period?.endDate || moment().endOf("day").toISOString();
      const createdAtFrom = period?.createdAtFrom || startDate;
      const createdAtTo = period?.createdAtTo || endDate;

      return forkJoin({
        purchases: ajax({
          url: `${API_BOS_URL}/statsAdmin/dashcamPurchases`,
          method: "POST",
          headers: Headers.get_auth(),
          body: JSON.stringify({ createdAtFrom, createdAtTo }),
        }),
        publishedReports: ajax({
          url: `${API_BOS_URL}/statsAdmin/dashcamPublishedReports`,
          method: "POST",
          headers: Headers.get_auth(),
          body: JSON.stringify({ startDate, endDate }),
        }),
        feedReactions: ajax({
          url: `${API_BOS_URL}/statsAdmin/dashcamFeedReactions`,
          method: "POST",
          headers: Headers.get_auth(),
          body: JSON.stringify({ startDate, endDate }),
        }),
      }).pipe(
        switchMap(({ purchases, publishedReports, feedReactions }) =>
          ActionsObservable.create((obs) => {
            const merged = {
              ...purchases?.response?.payload,
              ...publishedReports?.response?.payload,
              ...feedReactions?.response?.payload,
            };
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: merged,
            });
            if (onSuccess) onSuccess({ response: { payload: merged } });
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      );
    })
  );

export const getAverageSpeedEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    filter(({ payload }) => payload?.tab === "averageSpeed" || !payload?.tab),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/statsAdmin/averageSpeed`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload?.tab === "averageSpeed" ? payload : defaultPayload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response.payload,
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );

export const getNewPoliciesInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_NEW_POLICIES),
    mergeMap(({ payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/addedPolicies`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        mergeMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "newPolicies",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getAddedPoliciesInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_ADDED_POLICIES),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/orderedPolicies`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "orderedPolicies",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getOrderedInstallementsInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_INSTALLMENTS),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/orderedInstallments`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "installments",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getPaidFinesInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_PAID_FINES),
    mergeMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/paidFines`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        mergeMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "paidFines",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getVignettesInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_VIGNETTES),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/orderedVignettes`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "vignettes",
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getParkingInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_PARKING),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/parking`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "parking",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );

export const getClaimsInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_CLAIMS),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/claims`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "claims",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getCostsInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_COSTS),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/manualExpenses`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "costs",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getEventsInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_EVENTS),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/manualEvents`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "events",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getGeowashOrdersEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_GEOWASH_ORDERS),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/geoWash`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log(response);
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "geoWash",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getDashCamStatsEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_DASHCAM),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/dashcam`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log(response);
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "dashcam",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getDashcamPurchasesInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_DASHCAM_PURCHASES),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/dashcamPurchases`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            const page = payload.page ?? payload.pageNumber ?? 1;
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: { ...response.payload, page },
              key: "dashcamPurchases",
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getDashcamPublishedReportsInfoEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_DASHCAM_PUBLISHED_REPORTS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/dashcamPublishedReports`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            const page = payload.page ?? payload.pageNumber ?? 1;
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: { ...response.payload, page },
              key: "dashcamPublishedReports",
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
export const getAverageSpeedStatsEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_AVERAGESPEED),
    switchMap(({ onSuccess, payload }) =>
      ajax({
        url: `${API_BOS_URL}/admin/averageSpeed`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log(response);
            obs.next({
              type: AppStats.GET_INFO_SUCCESS,
              payload: response.payload,
              key: "averageSpeed",
            });
            payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error("Възникна грешка при обработката на информацията!");
            obs.complete();
          })
        )
      )
    )
  );
